<template>
  <div class="basicStyle">
    <div class="bg_fff">
      <el-card class="box-card">
        <el-form
          :inline="true"
          :model="searchFormObj"
          class="demo-form-inline"
          size="mini"
        >
          <el-form-item label="加入时间：" class="inline-form-item">
            <el-date-picker
              v-model="timeArr"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              end-placeholder="结束日期"
            />
          </el-form-item>
          <el-form-item label="" class="inline-form-item form-item-margin">
            <el-input
              v-model="searchFormObj.search"
              clearable
              placeholder="请输入姓名、手机号"
            />
          </el-form-item>
          <el-form-item label="来源" class="inline-form-item form-item-margin">
            <el-select
              v-model="searchFormObj.teacher_type"
              placeholder="请选择"
              filterable
            >
              <el-option
                v-for="item in teacherTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="订单数量类型"
            class="inline-form-item form-item-margin"
          >
            <el-select
              v-model="searchFormObj.order_type"
              placeholder="请选择"
              filterable
            >
              <el-option
                v-for="item in order_type_list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="添加方式" class="inline-form-item form-item-margin">
            <el-select v-model="searchFormObj.add_type" size="small" clearable>
              <!-- 1=手动添加，2=excel导入，3=H5注册 --> 
              <el-option label="全部" :value="0"></el-option>
              <el-option label="手动添加" :value="1"></el-option>
              <el-option label="excel导入" :value="2"></el-option>
              <el-option label="H5注册" :value="3"></el-option>
              <el-option label="小程序推广添加" :value="4"></el-option>
              <el-option label="学习卡激活添加" :value="5"></el-option>
              <el-option label="app自主注册" :value="6"></el-option>  
            </el-select> 
          </el-form-item>
          <el-form-item>
            <!-- <el-button
            type="primary"
            icon="el-icon-search"
            @click="onSearchSubmit"
            >搜索</el-button
          > 
          <el-button
            type="warning"
            icon="el-icon-refresh"
            @click="onSearchEmptySubmit"
            >重置</el-button
          > -->
            <MyButton
              value="搜索"
              size="medium"
              icon="el-icon-search"
              type="1"
              @click="onSearchSubmit"
            ></MyButton>
            <MyButton
              value="重置"
              size="medium"
              type="2"
              @click="onSearchEmptySubmit"
            ></MyButton>
          </el-form-item>
          <el-form-item
            label="绑定推广老师"
            class="inline-form-item form-item-margin"
          >
            <el-popover placement="top-start" width="200" trigger="hover">
              <div v-html="extendTeachTip" style="white-space: pre-line"></div> 
              <i
                class="el-icon--right questionIcon"
                slot="reference"
                style="margin-left: 5px"
              ></i>
            </el-popover>
          </el-form-item>
        </el-form>
      </el-card>

      <div class="table_box">
        <el-table
          v-loading="isLoading"
          :data="teachTableDataArr"
          style="width: 100%"
          border
          size="mini"
          @sort-change="sortChange"
          :row-class-name="tableRowClassName"
        >
          <el-table-column prop="realname" label="姓名" align="center" />
          <el-table-column prop="teacher_type" label="来源" align="center">
            <template slot-scope="scope">
              {{ teacherTypeMap.get(scope.row.teacher_type) }}
            </template>
          </el-table-column> 
          <el-table-column prop="mobile" label="手机号码" align="center" />
          <el-table-column
            prop="reg_people"
            label="招生数量（注册人数）"
            align="center"
            :render-header="regPeopleHeader"
            sortable="custom"
          >
            <template slot-scope="scope">
              <span class="blue-item" @click="regPeopleClick(scope.row)">
                {{ scope.row.reg_people }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="total_num"
            label="订单数量"
            align="center"
            :render-header="totalNumHeader"
            sortable="custom"
          >
            <template slot-scope="scope">
              <span class="blue-item" @click="totalNumClick(scope.row)">
                {{ scope.row.total_num }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="total_fee"
            label="订单金额"
            align="center"
            :render-header="totalFeeHeader"
            sortable="custom"
          />
          <el-table-column
            prop="total_tc_fee"
            label="累计收益"
            align="center"
            :render-header="renderHeader"
            sortable="custom"
          >
            <template slot-scope="scope"
              ><span class="red-item">{{
                scope.row.total_tc_fee
              }}</span></template
            >
          </el-table-column>
          <el-table-column
            prop="created_at"
            label="绑定机构时间"
            align="center"
          />
          <el-table-column
            prop="last_login_format"
            label="最近登录小程序时间"
            align="center"
          />

          <el-table-column prop="total_tc_fee" label="操作" align="center">
            <template slot-scope="scope">
              <span
                v-if="scope.row.teacher_type == 2"
                class="operationItem"
                @click="employeeDetails(scope.row)"
                >查看详情</span
              >
              <div v-else style="display: inline-block">
                <span class="operationItem" @click="teacherUnbind(scope.row)"
                  >解除绑定</span
                >
                <span class="operationItem" @click="teacherUpgrade(scope.row)"
                  >升级为员工</span
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="money-box">
        共计订单金额 <span>{{ total_fee }}</span
        >，累计收益 <span>{{ total_tc_fee }}</span>
      </div>

      <div class="page_box">
        <el-pagination
          :current-page="searchFormObj.page"
          background
          :page-sizes="[10, 20, 30, 50]"
          :page-size="searchFormObj.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="" :visible.sync="dialogVisible" width="415px">
      <div style="margin-bottom: 20px; text-align: center">
        请确定升级为员工的角色
      </div>
      <div style="text-align: center">
        <el-form :model="postForm">
          <el-form-item>
            <el-select
              v-model="postForm.role"
              placeholder="请选择"
              @change="$forceUpdate()"
            >
              <el-option
                v-for="item in roleOptions"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleSubmitPic">确 定</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import recruitStudentApi from "@/api/recruitStudent";
import commonApi from "@/api/common";
import { deepClone } from "@/utils";
import MyButton from "@/components/MyButton.vue";
import goodsApi from "@/api/goods.js";
export default { 
  name: "extendTeachManage",
  components: {
    MyButton,
  },
  data() {
    return {
      searchFormObj: {
        order_type: 0,
        teacher_type: 0,
        add_type: 0,
        search: "",
        limit: 20,
        page: 1,
      }, // 搜索数据
      timeArr: [], // 加入时间数组
      isLoading: false, // 表单加载状态
      total: 0, // 数据总数
      extendTeachTip: "", // 推广老师提示
      allMoneyTip: "", // 累计收益提示
      regPeopleTip: "", //招生数量提示
      totalNumTip: "", //订单数量提示
      totalFeeTip: "", //订单金额提示
      teachTableDataArr: [], // 老师表单数据
      total_fee: "", // 共计订单金额
      total_tc_fee: "", // 累计收益
      teacherTypeOptions: [
        {
          value: 0,
          label: "全部",
        },
        {
          value: 2,
          label: "员工",
        },
        {
          value: 3,
          label: "小程序绑定",
        },
      ],
      dialogVisible: false,
      roleOptions: [],
      postForm: {},
      order_type_list: [],
    };
  },
  created() {
    // 获取问号中的显示内容
    this.getDic();
    this.getList();
  },
  computed: {
    teacherTypeMap() {
      return new Map(
        this.teacherTypeOptions.map((item) => [item.value, item.label])
      );
    },
  },
  methods: {
    regPeopleClick(row){
     // 订单数量点击跳转到学员管理列表表
      this.$router.push({
        path: "/studentManage",
        query: {
          realname: row.realname,
        },
      }); 
    },
    totalNumClick(row){
     // 订单数量点击跳转到订单列表表
      this.$router.push({
        path: "/orderList",
        query: {
          realname: row.realname,
        },
      }); 
    },
    tableRowClassName({ row, rowIndex }) {
      if ((rowIndex + 1) % 2 == 0) {
        return "warning-row-color";
      }
      return "";
    },
    handleSubmitPic() {
      this.dialogVisible = false;
      console.log("this.postForm", this.postForm.role);

      goodsApi
        .teacherUpgrade({
          id: this.teacherUpgradeData.id,
          role: this.postForm.role,
        })
        .then((res) => {
          if (res.code == 200) {
            this.getList();
            this.$message.success("升级成功");
          } else {
            this.$message.error(res.message);
          }
        });
    },
    teacherUnbind(e) {
      // 解除绑定
      this.$confirm("解除绑定后，该推广员所有数据将清除", "确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          goodsApi.teacherUnbind({ id: e.id }).then((res) => {
            if (res.code == 200) {
              this.getList();
              this.$message.success(res.message);
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },
    teacherUpgrade(e) {
      this.roleOptions = this.$store.state.user.roleList;
      console.log("this.roleOptions", this.roleOptions);
      this.teacherUpgradeData = e;
      this.postForm.role = "nstitutionalteacher";
      this.dialogVisible = true;
    },
    employeeDetails(e) {
      // 员工详情
      this.$router.push({
        path: "/orderList",
        query: {
          realname: e.realname,
        },
      });
    },
    // 排序
    sortChange(e) {
      console.log("排序", e);
      this.searchFormObj.page = 1;
      if (e.order === "ascending") {
        // 升序
        this.searchFormObj.sort = e.prop;
        this.searchFormObj.sort_type = "asc";
        this.getList();
      } else if (e.order === "descending") {
        this.searchFormObj.sort = e.prop;
        this.searchFormObj.sort_type = "desc";
        this.getList();
      } else {
        delete this.searchFormObj.sort;
        delete this.searchFormObj.sort_type;
        this.getList();
      }
    },
    // 提交搜索表单
    onSearchSubmit() {
      console.log("搜索");
      this.searchFormObj.page = 1;
      this.getList();
    },
    // 重置表单
    onSearchEmptySubmit() {
      console.log("重置");
      this.searchFormObj = {
        order_type: 0,
        teacher_type: 0,
        add_type: 0,
        search: "",
        limit: 20,
        page: 1,
      };
      this.timeArr = [];
      this.getList();
    },
    // 每页尺寸改变函数
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.searchFormObj.limit = val;
      this.searchFormObj.page = 1;
      this.getList();
    },
    // 页码改变函数
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchFormObj.page = val;
      this.getList();
    },
    // 获取表单数据函数
    getList() {
      console.log("表单提交");
      this.isLoading = true;
      const query = deepClone(this.searchFormObj);
      console.log("timeArr", this.timeArr);
      if (this.timeArr && this.timeArr.length == 2) {
        query.join_time_start = this.timeArr[0];
        query.join_time_end = this.timeArr[1];
      }
      console.log("query", query);
      recruitStudentApi.getExtendTeachList(query).then((res) => {
        if (res.code === 200) {
          this.teachTableDataArr = res.data.data;
          this.total = res.data.total;
          this.total_fee = res.data.total_fee;
          this.total_tc_fee = res.data.total_tc_fee;
          this.isLoading = false;

          this.order_type_list = res.data.order_type_list;
        }
      });
    }, 
    getDic() {
      commonApi.getDictionaries({ names: "bktzkbzkbText,bktentitlementpicture" }).then((res) => {
        if (res.data && res.data.bktzkbzkbText.length > 0) {
          res.data.bktzkbzkbText.forEach((item) => {
            if (item.key === "zsguljsy_text") {
              // 累计收益提示
              this.allMoneyTip = item.value;
            } else if (item.key === "bdtgls_text") {
              // 推广老师提示
              this.extendTeachTip = item.value;
            }
          });
        }  
        if (res.data && res.data.bktentitlementpicture.length > 0) {
          res.data.bktentitlementpicture.forEach((item) => {
            if (item.key === "ZsslWord") { 
              // 招生数量提示 
              this.regPeopleTip = item.value;
            } else if (item.key === "DdsllWord") {  
              // 订单数量提示
              this.totalNumTip = item.value;
            } else if (item.key === "DdjellWord") {  
              // 订单金额提示
              this.totalFeeTip = item.value;
            }  
          });
        } 
      });
    }, 
    totalFeeHeader(h, { column }) {
      return h("span", [
        h(
          "el-popover",
          {
            props: {
              placement: "top-start",
              width: "200",
              trigger: "hover",
            },
          },
          [
            h("i", {
              class: "el-icon-question el-icon--right",
              style: "margin-right:5px;cursor:pointer;",
              slot: "reference",
            }),
            h("div", {
              domProps: {
                innerHTML: this.totalFeeTip, // 这里是要渲染的数据
              },
              style: "white-space: pre-line;",
            }),
          ]
        ),
        h("span", column.label),
      ]);
    }, 
    totalNumHeader(h, { column }) {
      return h("span", [
        h(
          "el-popover",
          {
            props: {
              placement: "top-start",
              width: "200",
              trigger: "hover",
            },
          },
          [
            h("i", {
              class: "el-icon-question el-icon--right",
              style: "margin-right:5px;cursor:pointer;",
              slot: "reference",
            }),
            h("div", {
              domProps: {
                innerHTML: this.totalNumTip, // 这里是要渲染的数据
              },
              style: "white-space: pre-line;",
            }),
          ]
        ),
        h("span", column.label),
      ]);
    }, 
    regPeopleHeader(h, { column }) {
      return h("span", [
        h(
          "el-popover",
          {
            props: {
              placement: "top-start",
              width: "200",
              trigger: "hover",
            },
          },
          [
            h("i", {
              class: "el-icon-question el-icon--right",
              style: "margin-right:5px;cursor:pointer;",
              slot: "reference",
            }),
            h("div", {
              domProps: {
                innerHTML: this.regPeopleTip, // 这里是要渲染的数据
              },
              style: "white-space: pre-line;",
            }),
          ]
        ),
        h("span", column.label),
      ]);
    }, 
    renderHeader(h, { column }) {
      return h("span", [
        h(
          "el-popover",
          {
            props: {
              placement: "top-start",
              width: "200",
              trigger: "hover",
            },
          },
          [
            h("i", {
              class: "el-icon-question el-icon--right",
              style: "margin-right:5px;cursor:pointer;",
              slot: "reference",
            }),
            h("div", {
              domProps: {
                innerHTML: this.allMoneyTip, // 这里是要渲染的数据
              },
              style: "white-space: pre-line;",
            }),
          ]
        ),
        h("span", column.label),
      ]);
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .box-card {
  padding: 20px 12px 0 12px;
  /deep/ .el-card__body {
    padding: 20px 0px;
  }
  /deep/ .el-form-item {
    margin-right: 0;
    .el-button {
      margin-left: 20px;
    }
  }
}
.form-item-margin {
  margin-left: 20px;
}
.table_box {
  margin-top: 20px;
}
.page_box {
  margin-top: 20px;
}
.money-box {
  text-align: end;
  margin-top: 12px;
  font-size: 16px;
  span {
    color: #d9001b;
  }
}
.blue-item {
  color: #846ffd;
  cursor: pointer;
}
.red-item {
  color: #d9001b;
}
.operationItem {
  display: inline-block;
  margin: 0 5px;
  cursor: pointer;
  color: rgb(87, 87, 239);
}
.operationItem:hover {
  color: red;
}
/deep/.questionIcon {
  width: 19px;
  height: 19px;
  background-image: url("../../assets/new/questionIcon_a1.png");
  background-size: 19px 19px;
  margin-left: 10px;
}
/deep/.questionIcon:hover {
  background-image: url("../../assets/new/questionIcon_a2.png");
  background-size: 19px 19px;
}
</style>
